import React from 'react';
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  selectCategoryEntities,
  selectCategoryIds,
  setNewParams,
  setReorderIds
} from "../../../../store/mine_craft/categoriesSlice";

import NavBarTwo from "src/componets/NavBarTwo";
import NavBarThree from "src/componets/NavBarThree";
import PageHeader from "src/componets/PageHeader";
import Can from "src/componets/Can";
import { PlusOutlined, SettingOutlined } from "@ant-design/icons";

interface propsInterface {
  title?: string | null;
  categoryId: any;
  targetId?: number;
  mainPage?: any;
}

const _PageHeader = ({ title, targetId, categoryId, mainPage }: propsInterface) => {
  const dispatch = useAppDispatch();
  const categories = useAppSelector(selectCategoryEntities);
  const ids = useAppSelector(selectCategoryIds);

  const category = categories[categoryId];
  const parentId: any = category?.parent_id;
  const parentCategory = categories[parentId];

  function onClickSettings() {
    dispatch(setReorderIds({ ids }));
  }

  function onClickCreate() {
    dispatch(setNewParams({ target_id: targetId }));
  }

  return (
    <>
      <PageHeader
        title='Content'
        breadcrumbs={[title, parentCategory?.title, category?.title]}
      >
        {
          categories &&
            <NavBarTwo
              items={categories}
              itemIds={ids}
              activeId={categoryId}
              parent={mainPage}
            />
        }

        <Can capability='write_minecraft'>
          <NavBarThree>
            <NavBarThree.Button onClick={onClickSettings}>
              <SettingOutlined /> Category Settings
            </NavBarThree.Button>
            <NavBarThree.Button onClick={onClickCreate}>
              <PlusOutlined /> Create Category
            </NavBarThree.Button>
          </NavBarThree>
        </Can>
      </PageHeader>
    </>
  )
}

export default _PageHeader;
